import { NoScoresAvailableMessage } from "src/components/Message/NoScoresAvailableMessage";
import { NoScoresForSsqMessage } from "src/components/Message/NoScoresForSsqMessage";
import { useEntityScoresOrUnavailable } from "src/context/Scores/useEntityScores";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

export const ProductScoresProtection = ({ children }: { children: ReactNode }) => {
    const entityScores = useEntityScoresOrUnavailable();
    const isProductUxV2 = useIsProductUxV2();

    if (entityScores.isAvailable) {
        return children;
    }

    if (entityScores.entitySsq?.scores.length === 0) {
        return <NoScoresForSsqMessage />;
    }

    return <NoScoresAvailableMessage appearance={isProductUxV2 ? "product-v2" : "legacy"} />;
};
